/* Fransk katalog for locale-payroll-employees-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'pay.personalia': 'État civil',
  'pay.personalInfo': 'Informations personnelles',
  'pay.edit': 'Modifier',
  'pay.documents': 'Documents',
  'pay.description': 'Description',
  'pay.contract': 'Contrat de travail',
  'pay.open': 'Ouvrir',
  'pay.download': 'Télécharger',
  'pay.delete': 'Supprimer',
  'pay.employment': 'Contrat de travail',
  'pay.positionAndAgreement': 'Poste et accord',
  'pay.searchOccupationCodes': 'Rechercher des codes métier ...',
  'pay.cancel': 'Annuler',
  'pay.saveEmployment': 'Enregistrer l\'emploi',
  'pay.employmentFrom': 'Emploi valable à partir du',
  'pay.employmentFromHint': 'La date à laquelle le salarié a eu, ou aura, son premier jour de travail dans votre entreprise. Cette date est indépendante du moment où vous avez commencé la comptabilité dans Plumme.',
  'pay.endDate': 'Date de fin',
  'pay.endDateHint': 'Laissez le champ vide tant que l\'emploi est toujours en cours.',
  'pay.occupationCode': 'Code métier',
  'pay.occupationCodeHint': 'Recherchez dans le registre public des codes métier et choisissez celui qui correspond le mieux. Le champ sert aux statistiques sur les métiers en Norvège.',
  'pay.employmentType': 'Type de relation de travail',
  'pay.employmentForm': 'Forme d\'emploi',
  'pay.workingHoursScheme': 'Régime horaire',
  'pay.workingHoursSchemeHint': 'La plupart des salariés relèvent de « Pas de travail posté », mais certains entrent aussi dans les autres catégories.',
  'pay.hoursFullWeek': 'Heures pour une semaine complète',
  'pay.salaryType': 'Type de salaire',
  'pay.hourlyPay': 'Salaire horaire',
  'pay.fixedPay': 'Salaire fixe',
  'pay.ftePercent': 'Taux d\'emploi',
  'pay.ftePercentHint': 'Choisissez un taux d\'emploi estimé. En cas de doute, indiquez le pourcentage le plus proche.',
  'pay.fullTime': 'Temps plein',
  'pay.partTime': 'Temps partiel',
  'pay.employmentScope': 'Volume d\'emploi',
  'pay.adjustHoursBy': 'Ajuster les heures par',
  'pay.perWeek': 'Par semaine',
  'pay.perMonth': 'Par mois',
  'pay.hoursPerWeek': 'Heures par semaine',
  'pay.hoursPerMonth': 'Heures par mois',
  'pay.otherEntityNumber': 'Autre numéro d\'établissement',
  'pay.optionalEntityNumber': 'Numéro d\'établissement facultatif',
  'pay.priorPayOutsidePlumme': 'Salaire antérieur hors Plumme versé par votre entreprise',
  'pay.priorPayHelp': 'Saisissez uniquement le salaire qui n\'est pas enregistré dans Plumme mais qui a été versé par l\'entreprise.',
  'pay.warning': 'Avertissement :',
  'pay.forPublicStatistics': 'Pour les statistiques publiques - à remplir uniquement si pertinent',
  'pay.lastAdjustmentDate': 'Date du dernier ajustement de salaire',
  'pay.salaryGrade': 'Échelon salarial',
  'pay.salaryGradePh': 'Ex. 45',
  'pay.agreedSalary': 'Salaire convenu',
  'pay.save': 'Enregistrer',
  'pay.annualSalary': 'Salaire annuel',
  'pay.agreementTaxHeading': 'Accord, congés payés, impôt et cotisations patronales',
  'pay.tax': 'Impôt',
  'pay.notFetchedFromAltinn': 'Non récupéré depuis Altinn',
  'pay.salaryPerYear': 'Salaire par an',
  'pay.holidayPay': 'Indemnité de congés payés',
  'pay.employerContribution': 'Cotisations patronales',
  'pay.estimatedTax': 'Impôt estimé',
  'pay.estimatedAnnualCost': 'Coût annuel estimé',
  'pay.noAgreedSalary': 'Aucun salaire convenu n\'a été saisi',
  'pay.taxCard': 'Carte d\'imposition',
  'pay.taxCardHelp': 'Les cartes d\'imposition ne sont pas encore récupérées. Cela sera connecté lorsque l\'intégration avec Skatteetaten sera prête.',
  'pay.fixedLines': 'Lignes fixes',
  'pay.fixedLinesHelp': 'Lignes de salaire normalement incluses dans chaque versement.',
  'pay.newFixedLine': 'Créer une ligne fixe',
  'pay.seeFixedLines': 'Voir les lignes de salaire fixes',
  'pay.payslips': 'Bulletins de paie',
  'pay.noPayslips': 'Aucun bulletin de paie n\'a encore été créé.',
  'pay.gross': 'Brut',
  'pay.paidOut': 'Versé',
  'pay.employeePortal': 'Portail salarié',
  'pay.employeePortalSub': 'Bulletins de paie, déplacements et notes de frais du salarié.',
  'pay.needEmailFirst': 'Saisissez une adresse e-mail valide dans le profil du salarié avant de donner l\'accès.',
  'pay.goToTravelExpenses': 'Aller aux déplacements et frais',
  'pay.saveEmployee': 'Enregistrer le salarié',
  'pay.nationalId': 'Numéro d\'identité national',
  'pay.hasInternationalId': 'A un identifiant international',
  'pay.name': 'Nom',
  'pay.phone': 'Numéro de téléphone',
  'pay.email': 'E-mail',
  'pay.address': 'Adresse',
  'pay.country': 'Pays',
  'pay.address1': 'Adresse 1',
  'pay.streetAddress': 'Adresse postale',
  'pay.address2': 'Adresse 2',
  'pay.optional': 'Facultatif',
  'pay.postalCode': 'Code postal',
  'pay.postalPlace': 'Ville',
  'pay.postalPlacePh': 'Ville ...',
  'pay.accountNumber': 'Numéro de compte',
  'pay.hasForeignAccount': 'A un numéro de compte étranger',
  'pay.mainOrSecondaryEmployer': 'Employeur secondaire/principal',
  'pay.taxAndDutyRules': 'Règles fiscales et de cotisations',
  'pay.noteOptional': 'Note (facultatif)',
  'pay.notePh': 'Écrire une note ...',
  'pay.employees': 'Salariés',
  'pay.employeesHelp': 'Le registre de tous les salariés de l\'entreprise. Appuyez sur un salarié pour voir son état civil, son emploi, son salaire et ses bulletins de paie.',
  'pay.allEmployees': 'Tous les salariés de votre entreprise',
  'pay.newEmployee': 'Nouveau salarié',
  'pay.newEmployeeHelp': 'Enregistrez un nouveau salarié avec son état civil, son emploi et ses conditions de rémunération. Le salarié est alors inclus dans les paies et l\'A-melding.',
  'pay.noEmployees': 'Aucun salarié pour l\'instant',
  'pay.salaryTypeLabel': 'Type de salaire :',
  'pay.status': 'Statut',
  'pay.statusHelp': 'Un emploi actif signifie que le salarié est inclus dans les paies. Terminé signifie que la relation de travail a pris fin.',
  'pay.payroll': 'Paie',
  'pay.payrollSub': 'Lancez la paie, suivez les salariés, les périodes et les congés payés.',
  'pay.payrollModuleHelp': 'Le module de paie regroupe tout ce qui concerne les salariés et la rémunération : exécution de la paie, cotisations patronales et prélèvement à la source, retraite (OTP), congés payés, déplacements et frais, et paramètres. Passez d\'une sous-page à l\'autre via le menu déroulant.',
  'pay.payrollPages': 'Pages de paie',
  'pay.payrollPagesHelp': 'Passez d\'une sous-page de la paie à l\'autre — Salariés, Versement des salaires, Cotisations patronales et impôt, Retraite/OTP, Lignes de salaire fixes, Déplacements et frais, Aperçu de la paie, Liste des congés payés, Paramètres de paie et Types de salaire.',
  'pay.employmentStatus': 'Statut d\'emploi',
  'pay.employmentStatusHelp': 'Indique si l\'emploi est actif ou terminé. Les salariés actifs sont inclus dans les paies et déclarés dans l\'A-melding.',
  'pay.backToPayrollRun': 'Retour au versement des salaires',
  'pay.showAllEmployees': 'Afficher tous les salariés',
  'pay.yourEmployers': 'Vos employeurs',
  'pay.yourClients': 'Vos clients',
  'pay.bgForEmployer': 'Couleur de fond pour cet employeur',
  'pay.bgColour': 'Couleur de fond',
  'pay.receiptHelp': 'Prenez une photo, téléversez, faites glisser ou collez. Les frais sans justificatif ne peuvent pas être soumis.',
  'pay.takePhoto': 'Prendre une photo',
  'pay.uploadFile': 'Téléverser une image/un fichier',
  'pay.remove': 'Retirer',
  'pay.registerExpense': 'Enregistrer une dépense',
  'pay.receiptRequired': 'Justificatif requis',
  'pay.category': 'Catégorie',
  'pay.pickCategory': 'Choisir une catégorie',
  'pay.date': 'Date',
  'pay.paidWith': 'Payé avec',
  'pay.privateExpense': 'Dépense personnelle',
  'pay.companyCard': 'Carte d\'entreprise/compte d\'exploitation',
  'pay.amount': 'Montant',
  'pay.currency': 'Devise',
  'pay.whatIsExpenseFor': 'À quoi correspond la dépense ?',
  'pay.registerTravel': 'Enregistrer un déplacement',
  'pay.sentForApproval': 'Envoyé pour approbation',
  'pay.dateFrom': 'Date de début',
  'pay.dateTo': 'Date de fin',
  'pay.travelType': 'Type de déplacement',
  'pay.travelWithExpenses': 'Déplacement avec frais/trajets',
  'pay.drivingOnly': 'Trajet uniquement',
  'pay.travelWithSubsistence': 'Déplacement avec indemnité de repas',
  'pay.destination': 'Destination',
  'pay.destinationPh': 'Ville, client ou lieu',
  'pay.from': 'De',
  'pay.startPlace': 'Lieu de départ',
  'pay.to': 'À',
  'pay.endPlace': 'Lieu d\'arrivée',
  'pay.kilometres': 'Kilomètres',
  'pay.purpose': 'Objet',
  'pay.purposeHelp': 'Quel était l\'objet du déplacement ?',
  'pay.note': 'Note',
  'pay.createTravelClaim': 'Créer une note de frais de déplacement',
  'pay.purposePh': 'Ex. réunion client à Drammen',
  'pay.whereDidYouGo': 'Où êtes-vous allé ?',
  'pay.norway': 'Norvège',
  'pay.tolls': 'Péages',
  'pay.tollsPaidWith': 'Péage payé avec',
  'pay.fromDate': 'Date de début',
  'pay.toDate': 'Date de fin',
  'pay.type': 'Type',
  'pay.hotel': 'Hôtel',
  'pay.otherAccommodation': 'Autre hébergement',
  'pay.guesthouse': 'Pension ou baraquement',
  'pay.place': 'Lieu',
  'pay.hotelOrPlace': 'Hôtel ou lieu',
  'pay.travelClaim': 'Note de frais de déplacement',
  'pay.rejectedByEmployer': 'Refusé par l\'employeur',
  'pay.newAccommodation': 'Nouvel hébergement',
  'pay.newTrip': 'Nouveau trajet',
  'pay.newExpense': 'Nouvelle dépense',
  'pay.noLinesYet': 'Aucune ligne pour l\'instant',
  'pay.employee': 'Salarié',
  'pay.subsistence': 'Indemnité de repas',
  'pay.payslip': 'Bulletin de paie',
  'pay.close': 'Fermer',
  'pay.netPaid': 'Net versé',
  'pay.period': 'Période',
  'pay.payAndDeductions': 'Salaire et retenues',
  'pay.grossPay': 'Salaire brut',
  'pay.withholdingTax': 'Prélèvement à la source',
  'pay.expenseRefund': 'Remboursement frais/déplacement',
  'pay.payslipPdfNote': 'L\'affichage PDF et l\'envoi seront connectés lorsque le générateur de bulletins de paie sera disponible dans Plumme.',
  'pay.noPayslipsYet': 'Aucun bulletin de paie pour l\'instant.',
  'pay.myExpenses': 'Mes dépenses',
  'pay.noExpensesInView': 'Aucune dépense dans cette vue.',
  'pay.expenses': 'Dépenses',
  'pay.preview': 'Aperçu',
  'pay.loadingReceipt': 'Chargement du justificatif...',
  'pay.canStillDownload': 'Le justificatif peut toujours être téléchargé manuellement.',
  'pay.cannotPreview': 'Ce type de fichier ne peut pas être prévisualisé ici.',
  'pay.openNewTab': 'Ouvrir dans un nouvel onglet',
  'pay.myTravel': 'Mes déplacements',
  'pay.noTravelInView': 'Aucun déplacement dans cette vue.',
  'pay.fetchingPortal': 'Chargement du portail salarié',
  'pay.portalFailed': 'Impossible de charger le portail salarié',
  'pay.back': 'Retour',
  'pay.noEmployers': 'Aucun employeur',
  'pay.home': 'Accueil',
  'pay.homeHelp': 'Votre page salarié chez l\'employeur sélectionné — bulletins de paie, notes de frais et déplacements.',
  'pay.myPage': 'Mon espace',
  'pay.myPageHelp': 'Votre compte personnel dans Plumme — profil, entreprises et finances personnelles.',
  'pay.signOut': 'Se déconnecter',
  'pay.paidByCompanyHint': 'Le justificatif est envoyé en comptabilité, pas en remboursement.',
  'pay.paidPrivateHint': 'Le montant vous est remboursé avec votre salaire.',
  'pay.expenseProject': 'Projet',
  'pay.expenseProjectHint': 'Une dépense liée à un projet peut être refacturée au client.',
  'pay.expenseNoProject': 'Hors projet',
  'pay.myHours': 'Mes heures',
  'pay.hoursThisMonth': '{time} ce mois-ci',
  'pay.hoursHelp': 'Les heures que vous avez saisies sur des projets pour cet employeur.',
  'pay.registerHours': 'Saisir des heures',
  'pay.timeNew': 'Saisir des heures',
  'pay.timeEdit': 'Modifier la saisie',
  'pay.timeDate': 'Date',
  'pay.timeProject': 'Projet',
  'pay.timeActivity': 'Activité',
  'pay.timeHours': 'Heures',
  'pay.timeNote': 'Note',
  'pay.timeNotePh': 'Sur quoi avez-vous travaillé ?',
  'pay.timePickProject': 'Choisir un projet …',
  'pay.timePickActivity': 'Choisir une activité …',
  'pay.timeSum': 'Total',
  'pay.timeSaved': 'La saisie a été enregistrée',
  'pay.timeDeleted': 'La saisie a été supprimée',
  'pay.timeFailed': 'Impossible d\'enregistrer la saisie.',
  'pay.timeLocked': 'La saisie des heures pour cette période est marquée comme terminée.',
  'pay.timeLockedThrough': 'La saisie des heures est marquée comme terminée jusqu\'au {date} inclus.',
  'pay.timeEmptyTitle': 'Aucune heure cette semaine',
  'pay.timeEmpty': 'Appuyez sur « Saisir des heures » pour ajouter la première.',
  'pay.timeNoProjectsTitle': 'Aucun projet',
  'pay.timeNoProjects': 'Votre employeur n\'a pas encore créé de projets sur lesquels vous pouvez saisir des heures.',
  'pay.timePrevWeek': 'Semaine précédente',
  'pay.timeNextWeek': 'Semaine suivante',
  'pay.myEmployeePage': 'Ma page salarié',
  'pay.myEmployeePageHelp': 'Votre page en tant que salarié chez un employeur — distincte de toute comptabilité que vous tenez. Vous y voyez vos bulletins de paie et y enregistrez les notes de frais et déplacements qui doivent vous être remboursés. En haut, vous passez d\'un employeur à l\'autre.',
  'pay.employer': 'Employeur',
  'pay.employerHelp': 'L\'employeur concerné par cette page. Si vous travaillez à plusieurs endroits, changez ici — les bulletins de paie, notes de frais et déplacements affichent alors les chiffres de l\'employeur sélectionné.',
  'pay.payslipsHelp': 'Les bulletins de paie de l\'employeur — un aperçu du salaire, de la retenue d\'impôt et du montant versé pour chaque traitement de paie. Appuyez pour ouvrir.',
  'pay.expensesHelp': 'Les dépenses que vous avez avancées de votre poche et qui doivent vous être remboursées — par exemple un reçu payé à titre privé. Soumettez-les pour approbation, et elles seront remboursées via la paie.',
  'pay.travelHelp': 'Notes de frais de déplacement avec indemnités kilométriques, indemnités de repas et dépenses liées à un déplacement. Soumettez-les pour approbation et remboursement via la paie.',
  'pay.registerExpenseHelp': 'Enregistrez une nouvelle dépense que vous avez avancée — téléversez le reçu, indiquez le montant et son objet. Elle est envoyée à l\'employeur pour approbation et remboursement.',
  'pay.registerTravelHelp': 'Enregistrez une note de frais de déplacement — trajets (indemnités kilométriques), indemnités de repas et dépenses liées au déplacement. Elle est envoyée à l\'employeur pour approbation.',
  'pay.employmentStatusLabel.active': 'Contrat de travail actif',
  'pay.employmentStatusLabel.ended': 'Parti',
  'pay.employmentStatusLabel.future': 'Commence plus tard',
  'pay.taxRuleNotSupported': 'pas encore pris en charge',
  'pay.taxRuleNotSupportedHint': 'Plumme ne calcule que l\'impôt ordinaire et les cotisations patronales. Un traitement de paie incluant ce salarié ne peut pas être approuvé – traitez sa paie en dehors de Plumme.',
  'pay.portalEmploymentEnded': 'Votre contrat de travail a pris fin. Vous pouvez toujours consulter vos bulletins de paie, mais vous ne pouvez plus soumettre de nouvelles dépenses, déplacements ou heures. Contactez votre employeur si vous avez une dépense à vous faire rembourser.',
  'err.employeePortal.employmentEnded': 'Le contrat de travail a pris fin et le portail salarié est désormais en lecture seule. Demandez à l\'employeur d\'enregistrer la dépense.',
  'pay.foreignAmount.label': 'Montant payé en NOK',
  'pay.foreignAmount.hint': 'Le reçu est en {currency}. Indiquez ce que vous avez réellement payé en couronnes norvégiennes, par exemple d\'après votre relevé bancaire. La dépense ne peut pas être approuvée sans montant en NOK.',
  'pay.foreignAmount.rateHint': 'Correspond à un taux de {rate} NOK par {currency}.',
  'pay.foreignAmount.missing': 'Montant en NOK manquant',
  'pay.foreignAmount.missingOnApproval': 'La dépense « {description} » est en {currency} et n\'a pas de montant en NOK. Modifiez la ligne et saisissez le montant réellement payé en NOK avant d\'approuver.',
  'err.payroll.foreignAmountMissingNok': 'Une dépense en devise étrangère n\'a pas de montant en NOK. Saisissez le montant réellement payé en NOK avant d\'approuver.',
  'pay.tabSalaryTax': 'Salaire & impôts',
  'pay.tabPayslipsExpenses': 'Bulletins de paie & dépenses',
  'pay.taxRuleOption.ordinary': 'Ordinaires',
  'pay.taxRuleOption.svalbard': 'Svalbard',
  'pay.taxRuleOption.janMayen': 'Jan Mayen et territoires dépendants',
  'pay.taxRuleOption.seafarerDeduction': 'Déduction spéciale pour les marins',
  'pay.taxRuleOption.charity': 'Organisation caritative ou d\'utilité publique',
  'pay.taxRuleOption.netPay': 'Salaire net',
  'pay.taxRuleOption.netPaySeafarer': 'Salaire net pour les marins',
  'pay.taxRuleOption.pensionSourceTax': 'Retenue à la source sur les pensions',
  'pay.taxRuleOption.nanny': 'Assistante maternelle au domicile de l\'enfant',
  'pay.taxRuleOption.homeWork': 'Travail salarié au domicile',
  'pay.taxRuleOption.taxFreeOrg': 'Organisation exonérée d\'impôt',
  'pay.employmentTypeOption.ordinary': 'Contrat de travail ordinaire',
  'pay.employmentTypeOption.maritime': 'Contrat de travail maritime',
  'pay.employmentTypeOption.freelance': 'Indépendant, prestataire ou bénéficiaire d\'honoraires',
  'pay.employmentTypeOption.pension': 'Pension ou autre relation soumise à retenue',
  'pay.employmentTypeOption.notEmployed': 'Non salarié',
  'pay.employmentTypeOption.simplifiedPrivate': 'Régime de règlement simplifié, employeur particulier',
  'pay.employmentTypeOption.simplifiedCharity': 'Régime de règlement simplifié, organisation caritative',
  'pay.employmentTypeOption.foreignService': 'Relation de service étrangère',
  'pay.employmentTypeOption.boardFee': 'Jetons de présence',
  'pay.employmentFormOption.permanent': 'Permanent',
  'pay.employmentFormOption.temporary': 'Temporaire',
  'pay.employmentFormOption.temporarySubstitute': 'Temporaire, remplaçant sur appel',
  'pay.employmentFormOption.permanentHiredOut': 'Emploi permanent, mis à disposition',
  'pay.employmentFormOption.temporaryHiredOut': 'Emploi temporaire, mis à disposition',
  'pay.shift.offshore': 'Offshore',
  'pay.hourlyOvertimePay': 'Salaire horaire - heures supplémentaires',
  'pay.fixedLine': 'Ligne fixe',
  'pay.portalAccess.notInvited': 'Accès non accordé',
  'pay.portalAccess.active': 'Accès actif',
  'pay.portalAccess.revoked': 'Accès révoqué',
  'pay.documentUploaded': 'Document téléversé.',
  'pay.documentsUploaded': 'Documents téléversés.',
  'pay.documentDeleted': 'Document supprimé.',
  'pay.amountRequired': 'Saisissez un montant.',
  'pay.fixedLineDeleted': 'Ligne de paie fixe supprimée.',
  'pay.fixedLineDeleteFailed': 'Impossible de supprimer la ligne de paie fixe.',
  'pay.emailRequiredFirst': 'Saisissez d\'abord une adresse e-mail valide dans le profil du salarié.',
  'pay.portalAccessSent': 'Accès envoyé à {email}.',
  'pay.portalAccessRevokedToast': 'Accès révoqué.',
  'pay.portalAccessSendFailed': 'Impossible d\'envoyer l\'accès.',
  'pay.portalAccessRevokeFailed': 'Impossible de révoquer l\'accès.',
  'pay.saveEmployeeFailed': 'Impossible d\'enregistrer le salarié.',
  'pay.confirmDeleteDocument': 'Supprimer le document « {name} » ?',
  'pay.confirmDeleteFixedLine': 'Supprimer la ligne de paie fixe « {line} » pour {name} ?',
  'pay.confirmRevokePortalAccess': 'Révoquer l\'accès au portail salarié pour {name} ?',
  'pay.taxCardValidUntil': 'Carte d\'imposition valable jusqu\'au',
  'pay.leaveOfAbsence': 'Congés',
  'pay.noLeaveRegistered': 'Aucun enregistré',
  'pay.loginEmail': 'E-mail de connexion',
  'pay.lastSent': 'Dernier envoi',
  'pay.revoked': 'Révoqué',
  'pay.bankAccount': 'Compte bancaire',
  'pay.hoursInFullWeek': 'Heures pour une semaine complète',
  'pay.uploading': 'Téléversement ...',
  'pay.newDocument': 'Nouveau document',
  'pay.resendAccess': 'Renvoyer l\'accès',
  'pay.grantEmployeeAccess': 'Donner accès au salarié',
  'pay.revoking': 'Révocation ...',
  'pay.revokeAccess': 'Révoquer l\'accès',
  'pay.portalAccessExplain': 'L\'accès est lié à l\'e-mail et à l\'identifiant du salarié. L\'espace salarié utilise ce lien lorsque la connexion au portail est activée.',
  'pay.useStandardHolidayRate': 'Utiliser le taux standard des paramètres de paie ({rate} %)',
  'pay.priorYearSalaryHeading': 'Salaire en {year}',
  'pay.payrollDataHidden': 'Les données de paie sont masquées pour cet accès',
  'pay.payrollDataHiddenBody': 'Les salariés, les lignes de paie fixes et les versements de salaire se trouvent dans un document du personnel distinct. Votre rôle pour ce client est {role}, et l\'application n\'a pas pu lire le document du personnel. Les déplacements et notes de frais comptabilisés peuvent donc toujours être affichés.',
  'pay.unknownAccess': 'accès inconnu',
  'pay.readAccess': 'Accès en lecture',
  'pay.registerFirstEmployee': 'Enregistrez votre premier salarié pour utiliser les traitements de paie, les cartes fiscales et l\'A-melding.',
  'pay.mainEmployerOption': 'Employeur principal',
  'pay.secondaryEmployerOption': 'Employeur secondaire',
  'pay.documentsCount': '{count} documents',
  'pay.noDocumentsUploaded': 'Aucun document téléversé',
  'pay.cannotOpenDocument': 'Impossible d\'ouvrir le document.',
  'pay.cannotDownloadDocument': 'Impossible de télécharger le document.',
  'pay.endEmployment': 'Mettre fin au contrat',
  'pay.reopenEmployment': 'Rouvrir le contrat',
  'pay.earnedHolidayPayInYear': 'Indemnité de congés payés acquise en {year}',
  'pay.holidayPayNotPaidBeforeStartHint': 'Indemnité de congés payés non versée avant la date de démarrage dans Plumme.',
  'pay.earnedTaxablePayInYear': 'Salaire acquis (base imposable) en {year}',
  'pay.grossPayNotInPlummeHint': 'Salaire brut versé par l\'entreprise en {year} et non enregistré dans Plumme.',
  'pay.withheldTaxInYear': 'Impôt prélevé en {year}',
  'pay.priorYearAmountWarning': 'Ne renseignez les montants de {year} que s\'ils ne sont pas inclus dans d\'autres versements de salaire enregistrés dans Plumme.',
  'pay.agreedSalaryInternalNote': 'Le salaire convenu sert uniquement de documentation interne. Les traitements de paie reposent sur des lignes de paie fixes ou manuelles.',
  'pay.estimatedAnnualSalaryFrom': 'Le salaire annuel estimé est calculé à partir de {summary}',
  'pay.fixedLinesRegisteredCount': '{count} enregistrée(s)',
  'pay.fixedLinesOnEmployee': 'Lignes de paie fixes de ce salarié.',
  'pay.noFixedLinesRegistered': 'Aucune ligne fixe n\'est enregistrée.',
  'pay.internalDocumentationNote': 'Il s\'agit d\'une documentation interne. Les traitements de paie utilisent des lignes de paie fixes ou des lignes manuelles sur le versement de salaire.',
  'pay.noAgreedSalaryBody': 'Saisissez un salaire annuel ou horaire pour voir le coût annuel estimé, l\'indemnité de congés payés, les cotisations patronales et l\'impôt.',
  'pay.selectOccupationCode': 'Choisir un code profession ...',
  'pay.noOccupationCodeMatch': 'Aucun résultat pour « {query} ».',
  'pay.editEmployeeTitle': 'Modifier le salarié',
  'pay.newEmployeeTitle': 'Nouveau salarié',
  'err.nativeValidation.payrollManualAMelding.1': 'L\'enregistrement manuel de l\'A-melding nécessite une paie norvégienne.',
  'err.nativeValidation.payrollManualAMelding.2': 'Le dépôt manuel doit être confirmé explicitement.',
  'err.nativeValidation.payrollManualAMelding.3': 'Une période de déclaration valide, une date de dépôt et une référence manuelle doivent être indiquées.',
  'err.nativeValidation.payrollManualAMelding.4': 'La date de dépôt doit être postérieure au mois déclaré et ne peut pas être dans le futur.',
  'err.nativeValidation.payrollManualAMelding.5': 'Confirmez exactement les traitements de paie comptabilisés du mois déclaré.',
  'err.nativeValidation.payrollManualAMelding.6': 'La référence de déclaration manuelle est déjà enregistrée pour ce mois.',
  'err.nativeValidation.pensionPremiumMutation.1': 'Le paiement de retraite nécessite une comptabilité norvégienne en NOK.',
  'err.nativeValidation.pensionPremiumMutation.2': 'Un justificatif de retraite valide et une date doivent être indiqués.',
  'err.nativeValidation.pensionPremiumMutation.3': 'Ce paiement de retraite prend uniquement en charge les taux vérifiés de 2026 pour la zone I.',
  'err.nativeValidation.pensionPremiumMutation.4': 'Le paiement de retraite utilise le compte bancaire NOK 1920.',
  'err.nativeValidation.pensionPremiumMutation.5': 'Les montants de retraite doivent être des nombres finis, non négatifs, en øre entiers.',
  'err.nativeValidation.pensionPremiumMutation.6': 'Le paiement de retraite ne peut pas être enregistré avant la date comptable.',
  'err.nativeValidation.pensionPremiumMutation.7': 'L\'identifiant d\'écriture de la retraite est déjà réservé.',
  'err.nativeValidation.pensionPremiumMutation.8': 'L\'historique de numérotation des retraites n\'est pas valide.',
});
